import React from 'react';

export default class EsignLandingPagePhotoToPDFModal extends React.PureComponent {

  static createPDF() {
    window.Upload.photoToPDF.createPDF();
    window._track('create-pdf-from-image', 'edit-pdf page');
  }

  render() {
    return (
      <div id="photoToPDF" className="hidden centered photoToPDF">
        <div id="addPages" className="btn btn-large btn-custom_info is-big">
          <input
            type="file"
            accept={
              `application/msword,
              application/vnd.openxmlformats-officedocument.wordprocessingml.document
              application/pdf,
              image/*`
            }
            id="selectPhotos"
            name="files[]"
            multiple
          />
          Add Pages <i className="icon-camera icon-white" />
        </div>
        <button
          id="createPDF"
          onClick={EsignLandingPagePhotoToPDFModal.createPDF}
          className="btn btn-large btn-custom_info btn-green is-big create-pdf-from-image-button"
        >
          <span>Create PDF</span>
        </button>
        <div className="photo-wrapper">
          <ul id="photoList" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/EsignLandingPage/EsignLandingPagePhotoToPDFModal.jsx